//Copyright (C) Siemens Healthineers AG 2024, All rights reserved. Restricted
//
/**
 * Created by z003f2zh on 21.09.2016.
 */

(function () {

    'use strict';

    angular.module('container.widgets')
        .directive('srsngTableColumnNumberFilter', srsngTableColumnNumberFilter);

    function srsngTableColumnNumberFilter($timeout) {

        return {
            restrict: 'E',
            templateUrl: 'container/ui/app/widgets/mega-table/filter/number/number.html',
            scope: {
                data: '='
            },
            controller: controller,
            link: link
        };

        function controller($scope, MegaTableItemProperty, sortService, SortDirection) {

            $scope.MegaTableItemProperty = MegaTableItemProperty;

            $scope.toggleShowAll = () => {

                $scope.data.textItems.forEach(item => {

                    if ($scope.data.showAllTextItems)
                        delete item[MegaTableItemProperty.HIDDEN];
                    else
                        item[MegaTableItemProperty.HIDDEN] = true;
                });

                $scope.filter();
            };

            $scope.itemVisible = item => {

                return !item[MegaTableItemProperty.HIDDEN];
            };

            $scope.toggleVisibility = item => {

                if (item[MegaTableItemProperty.HIDDEN])
                    delete item[MegaTableItemProperty.HIDDEN];
                else
                    item[MegaTableItemProperty.HIDDEN] = true;

                $scope.data.showAllTextItems = $scope.data.textItems.every(item => !item[MegaTableItemProperty.HIDDEN]);

                $scope.filter();
            };

            $scope.search = () => {

                $scope.filter();
            };

            $scope.sort = () => {

                $scope.filter();
            };

            $scope.filter = () => {
                $scope.data.callback($scope.data);
            };

            init();

            function init() {

                if ($scope.data.textItems == null) {
                    $scope.data.textItems = _.uniqBy($scope.data.unfilteredItems.map(item => {
                        return {[$scope.data.columnKey]: item[$scope.data.columnKey]};
                    }), $scope.data.columnKey);
                    $scope.data.textItems = sortService.sortItemsByNumber($scope.data.textItems, $scope.data.columnKey, SortDirection.ASC);
                }

                $scope.data.showAllTextItems = $scope.data.textItems.every(item => !item[MegaTableItemProperty.HIDDEN]);
            }
        }

        function link(scope, element, attrs) {

            element.on('$destroy', function () {
                scope.$evalAsync(function () {
                    scope.$destroy();
                });
            });
        }
    }
})();
